"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columnTransformDependencies = void 0;

var _dependenciesIndexClassGenerated = require("./dependenciesIndexClass.generated.js");

var _dependenciesMatrixGenerated = require("./dependenciesMatrix.generated.js");

var _dependenciesRangeGenerated = require("./dependenciesRange.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var columnTransformDependencies = {
  IndexDependencies: _dependenciesIndexClassGenerated.IndexDependencies,
  matrixDependencies: _dependenciesMatrixGenerated.matrixDependencies,
  rangeDependencies: _dependenciesRangeGenerated.rangeDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createColumnTransform: _factoriesAny.createColumnTransform
};
exports.columnTransformDependencies = columnTransformDependencies;